export const DAYS = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday'
} as const
export type DayNumber = keyof typeof DAYS
export type DayRoman = typeof DAYS[keyof typeof DAYS]

export const MONTHS = {
  0: 'January',
  1: 'February',
  2: 'March',
  3: 'April',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'August',
  8: 'September',
  9: 'October',
  10: 'November',
  11: 'December'
} as const

export const MONTHS_SHORT = {
  0: 'Jan',
  1: 'Feb',
  2: 'Mar',
  3: 'Apr',
  4: 'May',
  5: 'Jun',
  6: 'Jul',
  7: 'Aug',
  8: 'Sep',
  9: 'Oct',
  10: 'Nov',
  11: 'Dec'
} as const

export type MonthNumber = keyof typeof MONTHS
export type MonthRoman = typeof MONTHS[keyof typeof MONTHS]
export type MonthShortRoman = typeof MONTHS_SHORT[keyof typeof MONTHS_SHORT]

export const getRomanDay = (day: DayNumber): DayRoman => DAYS[day]
export const getRomanMonth = (month: MonthNumber, shortend = false): MonthRoman | MonthShortRoman =>
  shortend ? MONTHS_SHORT[month] : MONTHS[month]
export const getFormatedDate = (date: Date) =>
  `${date.toLocaleTimeString([], { hour: 'numeric', minute: 'numeric', hour12: true })} ${date.getDate()} ${getRomanMonth(
    date.getUTCMonth() as MonthNumber,
    true
  )}, ${date.getFullYear()}`

export const getFormattedDateInLocalTime = (date: string) => {
  const dateWithUtcOffset = `${date}+00:00`
  const dateInLocalTime = new Date(
    new Date(dateWithUtcOffset).toLocaleString('en-US', { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone })
  )
  return getFormatedDate(dateInLocalTime)
}

const addZeroToStart = (number: number) => (number < 10 ? `0${number}` : number)
/**
 * @param date Date String
 * @returns yyyy-mm-ddThh:MM:ss
 */
export const getDateTimeFormat = (date: string) => {
  const singleDate = new Date(date)
  const onlyMonth = singleDate.getMonth() + 1
  const onlyDate = singleDate.getDate()
  const onlyHour = singleDate.getHours()
  const onlyMin = singleDate.getMinutes()
  const onlySec = singleDate.getSeconds()
  return `${singleDate.getFullYear()}-${addZeroToStart(onlyMonth)}-${addZeroToStart(onlyDate)}T${addZeroToStart(onlyHour)}:${addZeroToStart(
    onlyMin
  )}:${addZeroToStart(onlySec)}`
}
